export const editProfile = () => {
  const component = document.querySelector("[data-wm-edit-profile]");

  if (!component) {
    return;
  }

  let form;

  const loadForm = () => {
    form = document.querySelector("[data-wm-edit-profile-form]");
    form.addEventListener("submit", submitForm);
  };

  const disableForm = () => {
    [...form.querySelectorAll("input, select")].forEach(
      (element) => (element.readOnly = true)
    );

    form.style.pointerEvents = "none";
    form.style.opacity = ".6";
  };

  const internalPreloader = (action) => {
    const preloader = form.querySelector("[data-wm-preloader]");
    preloader.hidden = action !== "show";
  };

  const submitForm = (event) => {
    internalPreloader("show");

    disableForm();

    event.preventDefault();

    const payload = new URLSearchParams(new FormData(form));

    fetch("/me/update/", { method: "POST", body: payload }).then((response) => {
      wemove.triggerEvent("wm-hidePreloader");

      wemove.triggerEvent("wm-userProfileUpdated", {
        payload: payload,
        response: response,
      });

      internalPreloader("hide");

      wemove.triggerEvent("wm-closeDialog");
    });
  };

  document.addEventListener("wm-dialogOpened::data-wm-edit-profile", loadForm);
};
